export const PRINTFUL_PRODUCTS_FIELDS_LIST: any = [
    {attribute: "id", label: "Id", cssClass: ''},
    // {attribute: "main_category_id", label: "Main Category Id", cssClass: ''},
    {attribute: "parent_category", label: "Parent Category", cssClass: ''},
    {attribute: "category", label: "Category", cssClass: ''},
    {attribute: "image", label: "Image", cssClass: '', type: 'image'},
    {attribute: "title", label: "Title", cssClass: ''},
    // {attribute: "title", label: "Title", cssClass: '', secondaryAttribute: 'brand'},
    {attribute: "type", label: "Type", cssClass: ''},
    {attribute: "type_name", label: "Type Name", cssClass: ''},
    {attribute: "brand", label: "Brand", cssClass: ''},
    {attribute: "model", label: "Model", cssClass: ''},
    // {attribute: "currency", label: "Currency", cssClass: ''},
    {attribute: "techniques", label: "Techniques", cssClass: '', type: 'list-string'},
    {attribute: "variant_count", label: "Variant Count", cssClass: ''},
];


export const PRINTFUL_PRODUCTS_INPUT_FIELDS: any = [
    {attribute: "brand", label: "Brand", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "category", label: "Category", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "currency", label: "Currency", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "id", label: "Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "main_category_id", label: "Main Category Id", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "model", label: "Model", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "parent_category", label: "Parent Category", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "techniques", label: "Techniques", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "title", label: "Title", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "type", label: "Type", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "type_name", label: "Type Name", type: 'text', group: 'detail', cssClass: ''},
    {attribute: "variant_count", label: "Variant Count", type: 'text', group: 'detail', cssClass: ''},
];
